import dynamic from 'next/dynamic';
// import PDFActivity from 'elem/compCommon/PillarPageActivities/PDFActivity';
import AMZMemberDay from 'elem/compCommon/PillarPageActivities/AMZMemberDay';
// import MemberDrainageBar from '@elem/compCommon/MemberDrainageBar';
import A from './components/A';
import FixTab from './components/FixTab';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function PowerBackup() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`power-backup ${css['power-backup']}`}>
            <A />
            <AMZMemberDay />
            <FixTab />
            <IndexDynamic />
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
